import LoadingSpinner from './Loading/LoadingSpinner';
import css from './css/PageLoader.module.css';

const PageLoader = ({text, small = false}) => {
    return (
        <div className={css.wrapper}>
            <LoadingSpinner text={text} small={small}/>
        </div>
    );
};

export default PageLoader;